module.exports = __webpack_public_path__ + "static/media/TommyShirtNormal.be5ae50c.jpg";